import React from 'react';
import { Loading } from '../Loading/Loading';

function Spinner() {
  return <Loading style={{ backgroundColor: 'transparent' }} />;
}

export default Spinner;
